import React, {useState} from 'react';

export default function EmailDirections(props) {
  const [email, setEmail] = useState('');
  const [requested, setRequested] = useState(false);

  const emailNow = () => {
    $.post('/get-directions', {email, sectionId: props.section.get('id')}).then((r) => {
      setRequested(true);
    });
  }

  return <>
    <div className="fragment-title">Get Directions Via Email</div>
    {requested ? <p>Directions have been sent to your email.</p> : <div>
      <input type='text' className='form-control' value={email} onChange={(e) => {
        setEmail(e.target.value);
      }} placeholder='Email Address'/>
      <button style={{marginTop: 20}} type='submit' className='btn btn-primary' onClick={emailNow}>Email Me Directions</button>
    </div>}
  </>;
}
